<template>
  <form :onsubmit="onSubmit" class="position-relative">
    <div class="col-auto">
      <!-- login -->
      <div class="text-start mb-1">
        <label class="h6 mb-0" for="inputLogin">
          {{ $t("hello.login.room.num", { room: $t(`change.room.${$hotel}`, 2) }) }}
        </label>
      </div>
      <div class="input-group mb-2 w-100 position-relative">
        <div class="input-group-text rounded-0 rounded-start bg-transparent">
          <i class="bi bi-person"></i>
        </div>
        <input
          type="text"
          class="form-control z-0 phone-input"
          id="inputLogin"
          placeholder="221"
          required
          v-model="login"
        />
      </div>

      <!-- password -->
      <div class="text-start mb-1">
        <label class="h6 mb-0" for="inputPassword">
          {{ $t("hello.login.room.pass") }}
        </label>
      </div>
      <div class="input-group mb-2 w-100 position-relative">
        <div class="input-group-text rounded-0 rounded-start bg-transparent">
          <i class="bi bi-lock"></i>
        </div>
        <input
          type="text"
          class="form-control z-0 phone-input"
          id="inputPassword"
          placeholder="XXXX"
          required
          v-model="password"
        />
      </div>
      <div class="input-hint text-muted small text-start">
        {{ $t("hello.login.room.hint") }}
      </div>
    </div>

    <button type="submit" class="btn btn-secondary w-100 mt-3">
      <span>{{ $t("app.onLogin") }}</span>
    </button>
  </form>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  components: {},
})
class LoginModal extends Vue {
  login = "";
  password = "";

  onSubmit(event: SubmitEvent): void {
    event.preventDefault();

    this.$emit("onLogin", this.login.trim(), this.password.trim());
  }
}
export default LoginModal;
</script>
<style lang="scss">
@import "@/assets/styles/bootstrap/variables";

.phone-input {
  height: 3.5rem;
  background: transparent;
}
.input-group > .phone-input {
  background-color: transparent !important;
}
.input-group > .phone-input:-webkit-autofill,
.input-group > .phone-input:-webkit-autofill:hover,
.input-group > .phone-input:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0 1000px transparent inset;
  -webkit-text-fill-color: var(--bs-body-color);
  transition: background-color 9999s ease-in-out 0s;
}
.input-group > .input-group-text:first-child {
  border-right: 0;
}
.input-group > .phone-input:last-child {
  border-left: 0;
}
.phone-input:focus {
  box-shadow: none;
  background: transparent;
  border-color: var(--bs-border-color);
}
</style>
